<script>
import ModalCloseButton from '@phoenix/mixins/components/common/ModalCloseButton';

export default {
  mixins: [ModalCloseButton],
};
</script>

<template>
  <button
    type="button"
    class="btn btn--sm btn--fade"
    :aria-label="$t('Accessibility.modal.close')"
    data-cy="modal-close-button"
    @click="closeModal(modalId)"
  >
    <span class="btn__text">{{ $t('Accessibility.modal.close') }}</span>
  </button>
</template>
